import React from 'react';
import { IonIcon } from '@ionic/react';
import { schoolOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { useKindergartenForMember } from '@/hooks/useKindergarten';
import { usePermission } from '@/hooks/usePermission';

interface Props {
  memberId: string;
}

/**
 * On a registry person page: this person's kindergarten links — as a parent
 * (their households) or as a child (their enrollment). Roster only.
 */
const MemberKindergartenCard: React.FC<Props> = ({ memberId }) => {
  const history = useHistory();
  const { can } = usePermission();
  const canOpenModule = can('kindergarten.manage') || can('kindergarten.finance_view');
  const { data } = useKindergartenForMember(memberId);

  const asGuardian = data?.as_guardian ?? [];
  const asChild = data?.as_child ?? [];
  if (asGuardian.length === 0 && asChild.length === 0) return null;

  const open = (householdId: string) => {
    if (canOpenModule) history.push(`/kindergarten/families/${householdId}`);
  };

  return (
    <div className="detail-card">
      <h3 className="detail-card__title">
        <IonIcon icon={schoolOutline} style={{ fontSize: 16, marginRight: 6, verticalAlign: -2, color: '#5e81f4' }} />
        Grădinița Gosen
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
        {asChild.map((child) => {
          const current = child.enrollments?.find((e) => e.school_year?.is_current) ?? child.enrollments?.[0];
          return (
            <div
              key={child.id}
              onClick={() => child.family && open(child.family.id)}
              style={{ padding: '10px 12px', borderRadius: 10, background: '#f8f9fc', cursor: canOpenModule ? 'pointer' : 'default' }}
            >
              <div style={{ fontWeight: 600, fontSize: 14 }}>Copil înscris</div>
              <div style={{ fontSize: 12, color: '#6b7280' }}>
                {current?.group ? `${current.group.display_name}` : 'Fără înscriere curentă'}
                {current?.school_year ? ` · ${current.school_year.name}` : ''}
                {child.family ? ` · ${child.family.name}` : ''}
              </div>
            </div>
          );
        })}
        {asGuardian.map((guardian) => (
          <div key={guardian.id} style={{ padding: '10px 12px', borderRadius: 10, background: '#f8f9fc' }}>
            <div style={{ fontWeight: 600, fontSize: 14 }}>Părinte</div>
            <div style={{ fontSize: 12, color: '#6b7280' }}>
              {(guardian.families ?? []).map((f) => (
                <span
                  key={f.id}
                  onClick={() => open(f.id)}
                  style={{ marginRight: 8, cursor: canOpenModule ? 'pointer' : 'default', textDecoration: canOpenModule ? 'underline' : 'none' }}
                >
                  {f.name} ({f.code})
                </span>
              ))}
              {(guardian.families ?? []).length === 0 && 'Fără familie asociată'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MemberKindergartenCard;
